/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';

export default class GoalController extends Controller {
  @service
  strings;

  EnrolmentStatus = EnrolmentStatus;

  @alias('model.goal')
  goal;

  @computed('model.states.[]')
  get learners() {
    let learners = [];
    this.get('model.states').forEach((state) => {
      let learner = state.get('person');
      // Add to learners array if it's the current state for the learner in question (and they are working on it)
      if (
        state.get('awarded') === GoalState.DEVELOPING &&
        state.id === this.findCurrentStateId(learner)
      ) {
        learners.push(learner);
      }
    });

    return learners;
  }

  findCurrentStateId(learner) {
    let states = this.get('model.states').filter(
      (item) => item.person.id === learner.get('id'),
    );
    if (states && states.length) {
      return states
        .slice()
        .sort((a, b) => a.createTime - b.createTime)
        .at(-1)?.id;
    }

    return null;
  }
}
